/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProductVo, RootObjectVo, SubmitVo } from "../checkout.interface";
import { SUBMIT_FLOOR_TYPE } from "../constants/submitType";
import { definedFloor, unfoldRootObject } from "./CommonDto2Vo";

/**
 * 将领域产品提单返回转化为传统楼层结构
 * @param floors
 */
function getFormatSubmitInfo(floors: RootObjectVo<any>[]): SubmitVo {
  // 提单结果
  let submit: SubmitVo = {
    orderId: "",
    outStockList: [],
    noStockTitle: "", // 无货标题
    stockStatus: "", // 无货状态
    orderType: "",
    useScore: "",
    idCompanyBranch: "",
    factPrice: "",
    idPaymentType: "",
    submitSkuNum: "",
    payId: "",
    payInfo: null,
  };

  if (!floors || !floors.length) {
    return submit;
  }

  floors.forEach((floor) => {
    // 提单结果
    if (definedFloor(floor, SUBMIT_FLOOR_TYPE.SUBMIT_FLOOR.SUBMIT_FLOOR_NAMESPACE)) {
      submit = unfoldRootObject(floor, SUBMIT_FLOOR_TYPE.SUBMIT_FLOOR.STRUCTURE) as any;
    }
    // 部分无货
    if (definedFloor(floor, SUBMIT_FLOOR_TYPE.SOME_OUT_STOCK_FLOOR.SOME_OUT_STOCK__NAMESPACE)) {
      const array: ProductVo[] = [];
      floor.partList?.forEach((node: any) => {
        array.push(
          unfoldRootObject(node, SUBMIT_FLOOR_TYPE.SOME_OUT_STOCK_FLOOR.PART_LIST_STRUCTURE) as any,
        );
      });
      submit.outStockList = array.map((sku: any) => {
        try {
          sku.attrList = JSON.parse(sku.saleAttributes).map((sku: any) => sku.saleValue);
        } catch (error) {
          sku.attrList = [];
        }
        return sku;
      });
      const noStockInfo = unfoldRootObject(
        floor,
        SUBMIT_FLOOR_TYPE.SOME_OUT_STOCK_FLOOR.STRUCTURE,
      ) as any;
      submit = { ...submit, ...noStockInfo };
    }
  });
  return submit;
}

export { getFormatSubmitInfo };
